import { ClmInstanceSelection } from 'features/cluster/autoscaler/components/ClmCompatibleFamiliesPicker';

export const buildKarpenterInstanceFamilySnippet = (
  clmInstanceSelection: ClmInstanceSelection
): string => {
  const families = JSON.stringify([
    clmInstanceSelection.baseInstance,
    ...clmInstanceSelection.compatibleInstances,
  ]);
  return `key: "karpenter.k8s.aws/instance-family"\noperator: In\nvalues: ${families}`;
};
